import { useState } from "react";
import { Button } from "./ui/button";


export const PromosDeleteModal = ({ 
  isOpen, 
  onClose, 
  transaction, 
  onDeleteTransaction 
}) => {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    if (!transaction) return;
    
    setDeleting(true);
    const success = await onDeleteTransaction(transaction.id);
    setDeleting(false);
    
    if (success) {
      onClose();
    }
  };

  if (!isOpen || !transaction) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Are you sure?</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            &times;
          </button>
        </div>
        
        <p className="mb-6">
          This action cannot be undone. Are you sure you want to delete this transaction?
        </p>
        
        <div className="flex justify-center space-x-4">
          <Button
            variant="outline"
            onClick={onClose}
          >
            No
          </Button>
          <Button
            onClick={handleDelete}
            className="bg-red-500 hover:bg-red-600 text-white"
            disabled={deleting}
          >
            {deleting ? "Deleting..." : "Yes, Delete"}
          </Button>
        </div>
      </div>
    </div>
  );
};